import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import searchUser from '@/components/modalSearchUser/modalSearchUser'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { configService } from '@/settings/api-url'

@Component({
  components: {
    searchUser
  }
})
export default class Profile extends Vue {

  @Getter getWallet: any
  @Getter getUserPhoto: any
  @Getter getUser: any
  @Getter getMembership: any
  @Getter getCity;

  @Action action_getCart: any
  @Action action_getCity

  @State userPhoto: any
  @State user: any

  @Mutation PATH_TEMPORAL
  @Mutation IS_TOKEN

  dataUser = ''
  showRechargue = false
  searchUser = false

  mounted () {
  }

  get getTextPrime () {
    return this.getMembership && this.getMembership.status === 'active' ? 'Opciones Prime' : 'Activar Prime'
  }

  async logout () {
    try {
      delete configService.defaults.headers.common["Authorization"];
      localStorage.removeItem("_tc");
      this.$router.go(0);
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte. Por favor intenta de nuevo." + error
      });
    }
  }

  goTo(routeName) {
    this.$router.push({ name: routeName });
  }

  isCurrentRoute(value) {
    let response = false;
    const routeName = this.$route.name;
    if (routeName && routeName.length && value && value.length && routeName === value) {
      response = true;
    }
    return response;
  }
}
